import React from "react";
import { Link } from "react-router-dom";

export default function HomePage() {
  return (
    <div className="max-w-6xl mx-auto px-4 py-8">
      <div className="text-center mb-12">
        <h1 className="text-4xl font-bold text-gray-800 dark:text-white mb-4">Pata Yako - Here for you!</h1>
        <p className="text-xl text-gray-600 dark:text-gray-300">
          Find your lost items or help others find theirs
        </p>
      </div>

      <div className="grid md:grid-cols-3 gap-8">
        <div className="bg-white dark:bg-gray-800 p-6 rounded-lg shadow-md">
          <h2 className="text-2xl font-semibold mb-4 text-gray-800 dark:text-white">Lost Something?</h2>
          <p className="text-gray-600 dark:text-gray-300 mb-4">
            Check our database of found items to see if someone has found your lost property.
          </p>
          <Link to="/nearby" className="inline-block px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700">
            Browse Found Items
          </Link>
        </div>

        <div className="bg-white dark:bg-gray-800 p-6 rounded-lg shadow-md">
          <h2 className="text-2xl font-semibold mb-4 text-gray-800 dark:text-white">Found Something?</h2>
          <p className="text-gray-600 dark:text-gray-300 mb-4">
            Help reunite lost items with their owners by posting what you've found.
          </p>
          <Link to="/post" className="inline-block px-4 py-2 bg-green-600 text-white rounded hover:bg-green-700">
            Post Found Item
          </Link>
        </div>

        <div className="bg-white dark:bg-gray-800 p-6 rounded-lg shadow-md">
          <h2 className="text-2xl font-semibold mb-4 text-gray-800 dark:text-white">Nearby Items</h2>
          <p className="text-gray-600 dark:text-gray-300 mb-4">
            View items that have been found or reported lost in your immediate area.
          </p>
          <Link to="/nearby" className="inline-block px-4 py-2 bg-purple-600 text-white rounded hover:bg-purple-700">
            View Nearby
          </Link>
        </div>
      </div>
    </div>
  );
}